// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"d381d565","653":"46084f01","660":"4fe87c65","750":"6ca4e56e"}[chunkId] + ".chunk.js";
};